module.exports = __webpack_public_path__ + "static/media/6.f5eb964e.png";


//////////////////
// WEBPACK FOOTER
// ./src/emoji/6.png
// module id = 224
// module chunks = 0